import { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

/**
 *
 */
const getModalRootEl = () => (typeof document === 'object' ? document.getElementById('modal-root') : null);
/**
 *
 */
const getContentEl = () => (typeof document === 'object' ? document.getElementById('content') : null);

/**
 *
 * @param {object} props
 * @param {object} props.children
 * @param {boolean} props.preventBackgroundScroll
 */
function Modal({ children, preventBackgroundScroll }) {
  const elRef = useRef(
    typeof window !== 'undefined' ? document.createElement('div') : null,
  );

  const scrollPositionRef = useRef(null);

  useEffect(() => {
    const modalRootEl = getModalRootEl();
    const contentEl = getContentEl();

    if (modalRootEl && elRef.current) {
      modalRootEl.appendChild(elRef.current);
    }

    if (preventBackgroundScroll && contentEl) {
      scrollPositionRef.current = window.pageYOffset;
      contentEl.classList.add('verticalScrollDisabled');
    }

    return () => {
      if (modalRootEl && elRef.current) {
        modalRootEl.removeChild(elRef.current);
      }
      if (preventBackgroundScroll && contentEl) {
        contentEl.classList.remove('verticalScrollDisabled');
        if (scrollPositionRef.current !== null) {
          window.scrollTo(0, scrollPositionRef.current);
        }
      }
    };
  }, []);

  useEffect(() => {
    const contentEl = getContentEl();
    if (!contentEl) return;

    if (preventBackgroundScroll) {
      contentEl.classList.add('verticalScrollDisabled');
    } else {
      contentEl.classList.remove('verticalScrollDisabled');
    }
  }, [preventBackgroundScroll]);

  const modalRootEl = getModalRootEl();

  return modalRootEl && children
    ? ReactDOM.createPortal(children, elRef.current)
    : null;
}

export default Modal;
